import React from 'react';
import TweenOne from 'rc-tween-one';
import { Menu, Button } from 'antd';
import { getChildrenToRender } from './utils';
import { TwitterOutlined, MediumCircleFilled, MenuOutlined  } from "@ant-design/icons";
import ConnectWallet from "./ConnectWallet.jsx";
import { FaDiscord } from "react-icons/fa";
import { MEDIUM_URL, TWITTER_URL, DISCORD_URL } from "../constants";

const { Item, SubMenu } = Menu;

class Header2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneOpen: undefined,
    };
  }

  phoneClick = () => {
    const phoneOpen = !this.state.phoneOpen;
    this.setState({
      phoneOpen,
    });
  };

  render()   {
    const { dataSource, isMobile, ...props } = this.props;
    const { address, web3Modal, loadWeb3Modal, logoutOfWeb3Modal } = this.props;
    const { phoneOpen } = this.state;
    const navData = dataSource.Menu.children;
    const navChildren = navData.map((item) => {
      const { children: a, subItem, ...itemProps } = item;
      if (subItem) {
        return (
          <SubMenu
            key={item.name}
            {...itemProps}
            title={
              <div
                {...a}
                className={`header0-item-block ${a.className}`.trim()}
              >
                {a.children.map(getChildrenToRender)}
              </div>
            }
            popupClassName="header0-item-child"
          >
            {subItem.map(($item, ii) => {
              const { children: childItem } = $item;
              const child = childItem.href ? (
                <a {...childItem}>
                  {childItem.children.map(getChildrenToRender)}
                </a>
              ) : (
                <div {...childItem}>
                  {childItem.children.map(getChildrenToRender)}
                </div>
              );
              return (
                <Item key={$item.name || ii.toString()} {...$item}>
                  {child}
                </Item>
              );
            })}
          </SubMenu>
        );
      }
      return (
        <Item key={item.name} {...itemProps}>
          <a {...a} className={`header0-item-block ${a.className}`.trim()}>
            {a.children.map(getChildrenToRender)}
          </a>
        </Item>
      );
    });
    // Add the Connect Wallet as the last NavChild
    navChildren.push(
      <Item key="wallet-button-menu" className='header0-item-block header0-item header0-button'>
        <ConnectWallet
          address={address}
          web3Modal={web3Modal}
          loadWeb3Modal={loadWeb3Modal}
          logoutOfWeb3Modal={logoutOfWeb3Modal}
        />
      </Item>
    );

    const moment = phoneOpen === undefined ? 300 : null;
    delete props.web3Modal;
    delete props.loadWeb3Modal;
    delete props.logoutOfWeb3Modal;
    return (
      <TweenOne
        component="header"
        animation={{ opacity: 0, type: 'from' }}
        {...dataSource.wrapper}
        {...props}
      >
        <div
          {...dataSource.page}
          className={`${dataSource.page.className}${phoneOpen ? ' open' : ''}`}
        >
          <TweenOne
            animation={{ x: -30, type: 'from', ease: 'easeOutQuad' }}
            {...dataSource.logo}
          >
            <img width="100%" src={dataSource.logo.children} alt="img" />
          </TweenOne>
          <TwitterOutlined className="nav-social-icon" style={{ fontSize: '28px', color: '#f1c4a7' }} onClick={() => {window.open(TWITTER_URL, '_blank');}}/>
          <MediumCircleFilled className="nav-social-icon" style={{ fontSize: '28px', color: '#f1c4a7' }} onClick={() => {window.open(MEDIUM_URL, '_blank');}}/>
          <a href={DISCORD_URL} target="_blank"><FaDiscord className="anticon discord-icon nav-social-icon" style={{ fontSize: '28px', color: '#f1c4a7' }} /></a>
          {isMobile && (
            <div
              {...dataSource.mobileMenu}
              onClick={() => {
                this.phoneClick();
              }}
            >
              <em />
              <em />
              <em />
            </div>
          )}
          <TweenOne
            {...dataSource.Menu}
            animation={
              isMobile
                ? {
                    height: 0,
                    duration: 300,
                    onComplete: (e) => {
                      if (this.state.phoneOpen) {
                        e.target.style.height = 'auto';
                      }
                    },
                    ease: 'easeInOutQuad',
                  }
                : null
            }
            moment={moment}
            reverse={!!phoneOpen}
          >
            <Menu
              mode={isMobile ? 'inline' : 'horizontal'}
              defaultSelectedKeys={['sub0']}
              selectable={false}
              theme="dark"
              overflowedIndicator={<MenuOutlined />}
            >
              {navChildren}
            </Menu>
          </TweenOne>
        </div>
      </TweenOne>
    );
  }
}

export default Header2;
